/* eslint-disable no-console */
import axios from "axios"

import { CONNECTION_FAILED } from "const"
import {
    MicrosoftToken,
    MtDriveCloudInitClient,

    MtDriveCloudAuthUrl,
    MtDriveCloudAuthUrlResponse,

    MtDriveCloudConfirmCode,
    MtDriveCloudConfirmCodeResponse,

    MtDriveCloudConnect,
    MtDriveCloudConnectResponse,

    MtDriveCloudGetFile,
    MtDriveCloudGetFileResponse,

    MtDriveCloudUploadResponse,

    MtDriveCloudDelete,
    MtDriveCloudDeleteResponse,
} from "server/models"
import { POST } from "client/store/utils"
import { LangType } from "client/store"
import { UploadCallback } from "client/utils"
import { BalloonMessage } from "client/components"

export const MicrosoftCreateServerClient = (initData: MtDriveCloudInitClient) => (
    POST(
        "/microsoft/initConnection/createClient",
        JSON.stringify(initData),
    )
)

interface MicrosoftGenerateAuthUrlResponse {
    validation: string
    authUrl: string
}
export const MicrosoftGenerateAuthUrl = (props: MtDriveCloudAuthUrl, lang: LangType) => (
    POST(
        "/microsoft/initConnection/generateAuthUrl",
        JSON.stringify(props),
    ).then((res: MtDriveCloudAuthUrlResponse) => {
        if (res.errorMessage === CONNECTION_FAILED) {
            const response: MicrosoftGenerateAuthUrlResponse = {
                validation: lang.connectionFailed,
                authUrl: null,
            }
            return response
        }

        const response: MicrosoftGenerateAuthUrlResponse = {
            validation: null,
            authUrl: res.authUrl,
        }
        return response
    })
)

interface MicrosoftConfirmCodeResponse {
    validation: string
    token: MicrosoftToken
}
export const MicrosoftConfirmCode = (props: MtDriveCloudConfirmCode, lang: LangType) => (
    POST(
        "/microsoft/initConnection/confirmCode",
        JSON.stringify(props),
    ).then((res: MtDriveCloudConfirmCodeResponse) => {
        if (res.errorMessage === CONNECTION_FAILED) {
            if (res.error) console.log(res.error)
            const response: MicrosoftConfirmCodeResponse = {
                validation: lang.connectionFailed,
                token: null,
            }
            return response
        }

        const response: MicrosoftConfirmCodeResponse = {
            validation: null,
            token: res.token as MicrosoftToken,
        }
        return response
    })
)

export const MicrosoftConnect = (props: MtDriveCloudConnect) => (
    POST(
        "/microsoft/connect",
        JSON.stringify(props),
    ).then((res: MtDriveCloudConnectResponse) => {
        if (res.errorMessage) {
            BalloonMessage(`MS OneDrive: ${res.errorMessage}`)
            if (res.error) console.log(res.error)
        }
    })
)

export const MicrosoftGetObject = (props: MtDriveCloudGetFile) => (
    POST(
        "/microsoft/getObject",
        JSON.stringify(props),
    ).then((res: MtDriveCloudGetFileResponse) => {
        if (res.errorMessage) {
            BalloonMessage("Error file load. Check console")
            console.log(res.errorMessage)
            return null
        }
        return res.base64
    })
)

export const MicrosoftUpload = (
    file: File,
    accountId: number,
    callback: UploadCallback,
) => {
    const data = new FormData()
    data.append("file", file)
    data.append("accountId", accountId.toString())

    const apiUrl = process.env.NODE_ENV === "development" ? "/api" : ""

    axios.post(`${apiUrl}/microsoft/upload`, data)
    .then((res) => {
        const response = res.data as MtDriveCloudUploadResponse
        if (response.errorMessage) {
            BalloonMessage("Error upload. Check console")
            console.log(response.errorMessage)
            if (response.error) console.log(response.error)
            callback(null, null)
        }

        if (response.fileId && response.fileUrl) {
            callback(response.fileId, response.fileUrl)
        }
    })
}

export const MicrosoftDelete = (
    accountId: number,
    fileIds: string[],
) => {
    const data: MtDriveCloudDelete = {
        accountId,
        fileIds,
    }
    return POST(
        "/microsoft/delete",
        JSON.stringify(data),
    ).then((res: MtDriveCloudDeleteResponse) => {
        if (res.errorMessage) {
            BalloonMessage("Error delete. Check console")
            console.log(res.errorMessage)
            return false
        }
        if (res.errorArray && res.errorArray.length > 0) {
            BalloonMessage("Error delete. Check console")
            console.log(res.errorArray)
            return false
        }
        return res
    })
}
